import { Navigate } from "react-router";
import { useAuth } from "../../contexts/auth/useAuth";
import AdminProxyGuard from "./AdminProxyGuard";

const ProtectedAdminRoute = () => {
    const { authenticated, user } = useAuth();

    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    // Redirect to home if user is not an admin
    if (authenticated && user && !user.is_admin) {
        return <Navigate to="/" replace />;
    }

    return <AdminProxyGuard />;
};

export default ProtectedAdminRoute;
